// Copyright (c) 2023 Deere & Company

import DuplicatePinPlate, { getDefaultState as getDefaultDuplicatePinPlateData } from './duplicate-pin-plate';
import t from 'tcomb';

const DuplicatePinPlateView = t.list(DuplicatePinPlate, 'DuplicatePinPlateView');

export const getDefaultState = () => new DuplicatePinPlateView([getDefaultDuplicatePinPlateData()]);

export default DuplicatePinPlateView;
